export default {
    resalesLanding: {
        sentOn: "Enviado el",
        toggleContact: "Mostrar contacto de la agencia",
        propertyOffers: "Ofertas de propiedades",
        openGallery: "Abrir galería de fotos",
        prevPhoto: "Foto anterior",
        nextPhoto: "Foto siguiente",
        close: "Cerrar",
        photo: "Foto",
        description: "Descripción",
        more: "Más",
        less: "Menos",
        intFloorSpace: "Superficie útil",
        build: "Construido",
        terrace: "Terraza",
        garden: "Jardín",
        buildYear: "Año de construcción",
        fees: "Gastos",
        communityFees: "Gastos de comunidad",
        basuraTax: "Tasa de basura",
        ibiFees: "IBI",
        securityDeposit: "Fianza",
        perMonth: "/mes",
        perWeek: "/semana",
        disclaimer: "Aviso legal",
        energyCertificate: "Certificado energético",
        pending: "Pendiente",
        rating: "Calificación",
        presentedBy: "Presentado por",
        propertyDetails: "Detalles de la propiedad",
        reference: "Referencia",
        referenceShort: "Ref",
        unitUnavailable: "Ya no disponible",
        availableUnits: "Unidades disponibles y precios",
        availableUnitsShort: "Unidades disponibles",
        unit: "Unidad",
        type: "Tipo",
        floors: "Plantas",
        bedrooms: "Dorm.",
        bathrooms: "Baños",
        surfaceArea: "Interior",
        price: "Precio",
        status: "Estado",
        unitAvailable: "Disponible",
        unitReserved: "Reservado",
        unitSold: "Vendido",
        seeMore: "Ver más",
        seeLess: "Ver menos",
        floor: "Planta",
        storeys: "Plantas",
        keyReady: "Llave en mano",
        touristLicence: "Licencia turística",
        firstOccupationLicence: "Licencia de primera ocupación",
        notKnown: "No disponible",
        notProvided: "No facilitado",
        yes: "Sí",
        no: "No",
        mortgageAvailable: "Hipoteca disponible",
        guaranteedRental: "Alquiler garantizado",
        sellBeforeCompletion: "Cesión del contrato antes de la finalización",
        sellBeforeCompletionYes: "Permitida",
        sellBeforeCompletionNo: "No permitida",
        sellBeforeCompletionNotProvided: "No facilitado",
        reservation: "Reserva",
        contract: "Contrato",
        construction: "Construcción",
        completion: "Finalización",
        co2: "CO2",
        energyConsumption: "Consumo de energía",
        co2PerYear: "kg CO2/año",
        kwhPerYear: "kWh/año",
        features: "Características",
        viewDetails: "Ver detalles",
        hideDetails: "Ocultar detalles de la propiedad",
        backToResults: "Resultados",
        viewProperty: "Ver propiedad",
        prevProperty: "Anterior",
        nextProperty: "Siguiente",
        viewAllFeatures: "Ver todas las características",
        allFeatures: "Todas las características",
        infoOnRequest: "Información bajo petición",
        tbc: "P.C.",
        // En español la categoría va DELANTE del valor ("Piscina climatizada").
        featureCategoryLabels: { pool: "Piscina", views: "Vistas", parking: "Aparcamiento", kitchen: "Cocina", condition: "Estado", garden: "Jardín" },
        featureQualifierFormat: "{category} {value}",
        location: "Ubicación",
        agencyInformation: "Información de la Agencia",
        buyingCosts: "Gastos de compra",
        propertyPrice: "Precio de la propiedad:",
        priceNote: "**El precio no incluye impuestos ni gastos de compra.",
        estimatedPurchaseCosts: "Gastos de compra estimados:",
        hide: "Ocultar",
        showBreakdown: "Mostrar desglose de gastos de compra",
        purchaseCostBreakdown: "Desglose de gastos de compra",
        concept: "Concepto",
        application: "Aplicación",
        rowTransferTax: "ITP (impuesto de transmisiones, segunda mano)",
        rowVat: "IVA (obra nueva)",
        rowVatLand: "IVA",
        vatApplication: "10% (4% para vivienda protegida)",
        rowStampDuty: "Actos Jurídicos Documentados (AJD)",
        rowNotary: "Notaría",
        rowLandRegistry: "Registro de la Propiedad",
        officialTariff: "Tarifa oficial",
        costRangeNotePrefix: "*Los gastos totales del comprador suelen estar entre",
        and: "y",
        ofPurchasePrice: "del precio de compra.",
        costApproxNote: "*Los costes de compra estimados se facilitan únicamente a título orientativo. Los costes reales pueden variar según la propiedad y las circunstancias del comprador. Recomendamos obtener asesoramiento profesional para un cálculo exacto.",
        additionalInformation: "Información adicional",
        addInfoDocument: "*Documento de Información Abreviada disponible conforme al Decreto andaluz 218/2005",
        addInfoNoFees: "*El comprador no paga honorarios de agencia inmobiliaria",
        formHeading: "¿Le gustaría saber más sobre los precios y la propiedad?",
        firstName: "Nombre",
        enterNumber: "Introduzca el número",
        email: "Correo electrónico",
        searchCountry: "Buscar país o código",
        noMatches: "Sin resultados",
        consent: "Al hacer clic en el botón, usted consiente el tratamiento de sus datos personales de acuerdo con la Política de Privacidad, incluida la recopilación, el almacenamiento y el uso de la información proporcionada para contactarle y facilitarle la información necesaria.",
        send: "Enviar",
        contactUs: "Contáctenos",
        yourMessage: "Su mensaje",
        agreeData: "Acepto facilitar mis datos con el fin de recibir una respuesta a mi solicitud de información.",
        agreeContact: "Solicito ser informado y acepto ser contactado por la empresa responsable de la promoción o el comercializador correspondiente, a través de mis datos de contacto, que facilito voluntariamente para este fin.",
        reject: "Rechazar",
        like: "Me gusta",
        liked: "Guardada",
        rejected: "Rechazada",
        offerRejected: "Oferta rechazada",
        contact: "Contactar",
        call: "Llamar",
        calling: "Llamando a",
        noPhone: "No hay teléfono disponible",
        enquirySent: "Consulta enviada — le contactaremos",
        yourDetails: "sus datos",
        respondedTo: "respondidas",
        noProperties: "No hay propiedades para mostrar.",
        soldOutBody: "Las propiedades de esta oferta se han vendido o ya no están en el mercado. Contacte con la agencia para recibir una selección actualizada.",
        expiredTitle: "Este enlace de oferta ha caducado",
        expiredBody: "Póngase en contacto con la agencia para obtener un enlace actualizado y ver estas propiedades.",
        unavailableTitle: "Oferta no disponible",
        unavailableBody: "No hemos podido cargar esta oferta. Es posible que el enlace no sea válido o que el servicio no esté disponible temporalmente; inténtelo de nuevo más tarde o contacte con la agencia.",
    },
    title: "{agencyName}'s properties",
    in: "en",
    propertiesFound: "propiedades encontradas",
    toDay: "Hoy",
    days: "dias",
    week: "Semana",
    year: "Año",
    month: "Mes",
    prev: "Anterior",
    next: "Siguiente",
    backToList: "Última búsqueda",
    sorry: "Lo sentimos",
    cantFind: "no puedo encontrar",
    lookingFor: "la página que estás buscando ...",
    thankYou: "GRACIAS POR VISITAR NUESTRO SITIO WEB",
    pleaseContact: "Comuníquese con el agente para obtener una nueva URL.",
    ForSale: "VENTA",
    ShortTermRental: "ALQUILER CORTO",
    LongTermRental: "ALQUILER LARGO",
    showMore: "Mostrar más",
    showLess: "Mostrar menos",
    price: "Precio",
    pricePer: "Precio por",
    built: "Construido",
    floorSpace: "Útiles",
    terrace: "Terraza",
    garden: "Jardin",
    plot: "Terreno",
    propTitle: '{subType} {searchType} en {location}',
    propTitleShort: '{subType} en {location}',
    notAvailable: "No disponible",
    notFound: 'Página no encontrada',
    emptyProperties: "No se encontraron propiedades, por favor contactar con el agente para más información.",
    linkExpired: "Ups, este enlace ha caducado. Contacte con su agente inmobiliario para recibir un enlace de propiedades actualizado.",
    newDevelopment: "Nueva promoción",
    agencyRaiiNo: "Número de registro de la agencia",
    home: {
        verifyYourURLHere: "Verifique su URL aquí. Para hacer esto, inicie sesión en WhatsApp en su navegador web, luego copie la URL de WhatsApp aquí.",
        pasteUrlHere: "Pegar URL aquí",
        verifyUrl: "Verificar URL",
        whatIsPropertyViewer: "¿Qué es Property-Viewer.com?",
        thisIsWebsiteIsUsed: "Los agentes inmobiliarios utilizan este sitio web para enviar propiedades a sus clientes. Es un producto de {resalesonlinecom} En caso de duda, hable con el agente que le envió la lista de propiedades.",
        howDoesItWork: "¿Cómo funciona?",
        inThePast: "En el pasado, los agentes enviaban documentos PDF a sus clientes. Sin embargo, estos no son fáciles de ver en muchos dispositivos. Por lo tanto, creamos {propertyviewercom} para que el cliente pueda ver más fácilmente las propiedades que se les envían.",
        createAShortList: "El agente creará una breve lista de propiedades. Cuando compartan estas propiedades con usted, recibirá un vínculo. Al hacer clic en este enlace le mostrará las propiedades."
    },

    list: {
        propertyTitle: "Haga clic aquí para ver la información de esta propiedad"
    },

    searchType: {
        ForSale: "en venta",
        ShortTermRental: "en alquiler de corta temporada",
        LongTermRental: "en alquiler de larga temporada",
    },

    rsStatus: {
        Available: "Disponible",
        Listing: "Pendiente",
        UnderOffer: "Oferta Hecha",
        SaleAgreed: "Venta Acordada",
        OffMarket: "Retirada del Mercado",
        Sold: "Vendida",
        Rented: "Alquilado"
    },

    details: {
        average: "Media",
        averagePricesFor: "Media de precios para ",
        showFullER: "Mostrar Completo",
        thisProperty: "Esta propiedad",
        infoNotAvailable: "Esta información no está disponible.",
        feesEnergyRating: "Tarifas, Calificación de Energía",
        fees: "Gastos",
        ibiFees: "Gastos IBI",
        basuraTax: "Gastos Basura",
        communityFees: "Gastos de Comunidad",
        associatedCosts: "Costos asociados",
        energyRating: "Calificación Energética",
        securityDeposit: "Fianza",
        energyCertificate: "Certificado energético",
        energyCertificatePending: "El certificado energético está pendiente",
        energyConsumption: "Consumo de Energia",
        co2: "CO₂",
        co2PerYear: "kgCO₂/m² por año",
        kwhPerYear: "kWh/m² por año",
        other: "Otros",
        buildYear: "Año de construcción",
        forSale: "En venta",
        sold: "Vendido",
        longTerm: "Larga estancia",
        shortTermHigh: "Corta estancia, temporada Alta",
        shortTermLow: "Corta estancia, temporada Baja",
        allFeatures: "Todas las características",
        aproxLocation: "Localización aproximada",
        rentalLicenseRef: "Número Registro Turístico",
        notIncludeExpensesAndTaxes: "El precio no incluye gastos ni tributos. Los gastos adicionales al precio por parte del comprador son: Vivienda nueva/1ª transmisión Impuesto sobre el Valor Añadido (IVA) 10% (o 4% en caso de vivienda protegida); o en el caso de 2ª y/o posteriores transmisiones Impuesto sobre Transmisiones (ITP) según normativa autonómica vigente. Además, la formalización en documento público del contrato de compraventa (escrituras) podrá estar sujeta a AJD (Actos Jurídicos Documentados) según normativa aplicable, así como gastos de inscripción en el Registro y notaría. Información precontractual disponible conforme a la normativa aplicable en la Comunidad Autónoma correspondiente.",
        listingAgent: "Agencia Listadora",
        agencyInformation: "Información de la Agencia",
    },
};
